import React, { useEffect, useState } from 'react'
import { Grid, TextField, Divider, CircularProgress, Button } from '@material-ui/core'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import theme from 'theme'

import AddIcon from '@material-ui/icons/Add'
import { getLabelEndereco } from 'helpers/labels'
import { useLocal } from 'hooks/useLocal'
import { Form as FormAddLocal } from '../../views/Locais/EditarLocal/components/Form/Form'
import useStyles from './styles'


/** Em processo de descontinuação */
export const FormLocalDeColeta = (props) => {
  const { form, idCaso, idVeiculo, setDisableNextButton, children } = props
  const classes = useStyles()
  const localService = useLocal()
  const [isAddLocalOn, setIsAddLocalOn] = useState(false)
  const [locaisCaso, setLocaisCaso] = useState([])
  const [processando, setProcessando] = useState(false)

  useEffect(() => {
    const fetchLocais = async () => {
      if (idVeiculo) {
        await localService.listarLocaisDeCasosPorVeiculo(idVeiculo, setLocaisCaso, setProcessando)
        return
      }
      await localService.listarLocaisDeCaso(idCaso, setLocaisCaso, setProcessando)
    }
    fetchLocais()
  }, [idCaso, idVeiculo, setLocaisCaso, isAddLocalOn])

  useEffect(() => {
    if (!form.formState.values.endOrig) {
      if (locaisCaso.length) {
        form.setFormState((formState) => ({
          ...formState,
          values: {
            ...formState.values,
            endOrig: locaisCaso[0],
          },
        }))
      }
    }
  }, [locaisCaso])

  useEffect(() => {
    if (setDisableNextButton) {
      if (isAddLocalOn) {
        setDisableNextButton(true)
      } else {
        setDisableNextButton(false)
      }
    }
  }, [isAddLocalOn, setDisableNextButton])

  const handleClickAddLocal = () => {
    setIsAddLocalOn(true)
  }

  return (
    <Grid>
      {isAddLocalOn ? (
        <FormAddLocal local={{}} idCaso={idCaso} setOpenFicha={setIsAddLocalOn} />
      ) : (
        <Grid container justifyContent="space-between">
          {processando ? (
            <div className={classes.carregando}>
              <CircularProgress disableShrink />
            </div>
          ) : (
            <Grid className={classes.item} item md={12} sm={12} xs={12}>
              <Grid container justifyContent="space-between">
                <Grid />
                <Grid>
                  <Button className={classes.novoLocal} variant="contained" onClick={handleClickAddLocal}>
                    <AddIcon fontSize="small" className={classes.addIcon} />
                    Cadastrar novo local
                  </Button>
                </Grid>
              </Grid>
              <Grid container md={12} sm={12} xs={12} style={{ marginTop: '20px' }}>
                <Grid item md={12} sm={12} xs={12}>
                  <AutocompleteNative
                    name="endOrig"
                    noOptionsText="Sem informações"
                    options={locaisCaso}
                    value={form.formState.values.endOrig || null}
                    getOptionSelected={(option, value) => option === value || option.id === value.id}
                    onChange={(event, newValue) => {
                      form.handleChangeNewValueByNameProperty(event, newValue, 'endOrig')
                    }}
                    getOptionLabel={(option) => getLabelEndereco(option)}
                    renderOption={(option) => getLabelEndereco(option)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Selecione um dos locais cadastrados no caso"
                        required
                        InputLabelProps={{
                          shrink: true,
                          className: classes.labelInput,
                        }}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
          <Divider style={{ marginTop: theme.spacing(3) }} />
          {children}
        </Grid>
      )}
    </Grid>
  )
}
